export const CHAT_SESSIONS_ENDPOINT = '/c/v2/chat/sessions';
export const CREATE_CHAT_SESSIONS_ENDPOINT = '/c/v2.1/chat/sessions';

export const CHAT_SESSION_MESSAGES_ENDPOINT =
  '/c/v1/chat/sessions/:sessionId/messages/:messageIds';

export const CHAT_SESSION_ENDPOINT = '/c/v2/chat/sessions/:sessionId';
